import BrowseDeviationSelector from './BrowseDeviationSelector.connected';
export default BrowseDeviationSelector;
